<div class="app-splash-screen">
  <div class="app-splash-inner">
    <div class="app-logo"></div>
    <div class="app-label">
        Powered by
        <div class="app-epson">
          EPSON
        </div>
    </div>
    <div class="app-version ">
      V1.0
    </div>
  </div>
</div>
